import useCompanyInfoActions from 'dataflow/billingPortal/actions/useCompanyInfo.action';
import { convertArrayToDropdownArrayFormat, isArrayNotEmpty, isObjectNotEmpty, removeArrayDuplicates, removeMatching, removeNonMatching } from 'functions';
import { useCustomSelector } from 'hooks';
import { useEffect } from 'react';

export function useDropdownLists() {
    const {
        companyInfoOptionLists
    } = useCustomSelector("companyInfo");

    const { getCompanyInfoOptionLists } = useCompanyInfoActions();

    let serverNameList = [];
    let dbServerNameList = [];
    let appVersionList = [];
    let dbVersionList = [];
    if (isObjectNotEmpty(companyInfoOptionLists)) {
        serverNameList = companyInfoOptionLists?.ServerNames;
        dbServerNameList = companyInfoOptionLists?.DBServers;
        appVersionList = companyInfoOptionLists?.AppVersions;
        dbVersionList = companyInfoOptionLists?.DBVersions;
    }

    // Remove Duplicates
    serverNameList = removeArrayDuplicates(serverNameList, ["NA", "-"]);
    dbServerNameList = removeNonMatching(dbServerNameList, new RegExp("^(xilnexdb)", "gi"));
    dbServerNameList = dbServerNameList.map((value) => { return value.substring(8); })
    appVersionList = removeArrayDuplicates(appVersionList, ["NA", "-"]);
    dbVersionList = removeArrayDuplicates(dbVersionList, ["NA", "-"]);

    useEffect(() => {
        getCompanyInfoOptionLists();
    }, []);

    return {
        serverNameList: convertArrayToDropdownArrayFormat(serverNameList.sort()),
        dbServerNameList: convertArrayToDropdownArrayFormat(dbServerNameList.sort()),
        appVersionList: convertArrayToDropdownArrayFormat(appVersionList.sort()),
        dbVersionList: convertArrayToDropdownArrayFormat(dbVersionList.sort((a, b) => (a - b) ))
    }
}